import React from 'react';
import { Settings, BookOpen, Layers, Code2 } from 'lucide-react';
import SectionsPage from '../components/common/SectionsPage';

const SystemDesign: React.FC = () => {
  const sections = {
    fundamentals: {
      title: 'Fundamentals',
      icon: BookOpen,
      description: 'Master the basics of system design — start here',
      showDivider: true,
      cardVariant: 'detailed' as const,
      gridCols: 3 as const,
      maxRows: 2,
      showProgress: false,
      showStats: false,
    },
    'core-concepts': {
      title: 'Core Concepts',
      icon: Layers,
      description: 'Essential distributed system concepts for interviews',
      cardVariant: 'detailed' as const,
      gridCols: 3 as const,
      maxRows: 2,
      showProgress: false,
      showStats: false,
    },
    'design-patterns': {
      title: 'Design Patterns',
      icon: Code2,
      description: 'Master the Gang of Four design patterns with real examples',
      cardVariant: 'detailed' as const,
      gridCols: 3 as const,
      maxRows: 2,
      showProgress: false,
      showStats: false,
    },
  };

  return (
    <SectionsPage
      pageKey="system-design"
      className="nav-tab-page system-design-page"
      pageTitle="System Design"
      pageDescription="Master the art of designing scalable, distributed systems through structured learning paths and real-world examples"
      pageIcon={Settings}
      iconColor="text-purple-600 dark:text-purple-400"
      gradientColors={{
        from: 'from-purple-500',
        via: 'via-pink-500',
        to: 'to-rose-500',
      }}
      sections={sections}
      defaultSection="fundamentals"
      enableSearch={true}
      enableFilter={true}
      filterOptions={[
        { value: 'all', label: 'All Levels' },
        { value: 'beginner', label: 'Beginner' },
        { value: 'intermediate', label: 'Intermediate' },
        { value: 'advanced', label: 'Advanced' },
      ]}
    />
  );
};

export default SystemDesign;
